import { render, staticRenderFns } from "./ModalSelecionarTerritoriosAr.vue?vue&type=template&id=0da57819&lang=pug"
import script from "./ModalSelecionarTerritoriosAr.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarTerritoriosAr.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarTerritoriosAr.vue?vue&type=style&index=0&id=0da57819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports